// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"5e4cb4eb","551":"bac3a563","815":"65095c09"}[chunkId] + ".chunk.js";
};